import React from 'react'
import PropTypes from 'prop-types'

// components
import Snippets from 'search-new/components/Inline/components/Snippets'

// helper functions
import { renderText } from 'search-new/components/Inline/shared/functions'
import { stringContainsHTMLMarkup, checkParseAlertString, parseDateTime } from 'shared/imports/sharedHelperFunctions'

const InlineFeedItem = (props) => {
    const renderFields = (fields, bigCache) => (
        fields.map((field) => {
            let { label, values } = field
            if (label === "Created:" && bigCache.date_with_tz) {
                values = [parseDateTime(bigCache.date_with_tz)]
            }
            if (values &&
                (
                    values.constructor === Array ||
                    values instanceof Array ||
                    Array.isArray(values)
                )
                && values.length > 1
                && label !== "Matching Snippets:"
            ) {
                return (
                    <tbody key={`${props.inlineId}${label}`}>
                        <tr className="inline-feed-item-table-row">
                            <td><b>{label}</b></td>
                            <td>
                                <div className="alert-full-content">
                                    <Snippets
                                        inlineId={props.inlineId}
                                        isExpanded
                                        isSearchify={props.isSearchify}
                                        snippets={values}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                )
            } else if (
                label !== "Matching Snippets:" &&
                label !== "Stance:" &&
                label !== "Priority:"
            ) {
                return (
                    <tbody key={`${props.inlineId}${label}`}>
                        <tr className="inline-feed-item-table-row">
                            <td><b>{`${label}`}</b></td>
                            <td>
                                <span>
                                    {
                                        values.map((value) => {
                                            const parsedValue = checkParseAlertString(value)

                                            return renderText({
                                                lineData: parsedValue,
                                                isHtml: stringContainsHTMLMarkup(parsedValue),
                                                inlineId: props.inlineId,
                                                isSearchify: props.isSearchify,
                                            })
                                        })
                                    }
                                </span>
                            </td>
                        </tr>
                    </tbody>
                )
            }

            return undefined
        })
    )

    if (props.bigCache) {
        const { bigCache } = props
        const { fields } = bigCache

        return (
            <div className="alert-feed">
                <table className="inline-feed-item-table">
                    <tbody>
                        <tr className="inline-feed-item-table-row">
                            <td><b>Data Type:</b></td>
                            <td>{props.quorumDataType ? props.quorumDataType.singular : "Unknown"}</td>
                        </tr>
                    </tbody>
                    {renderFields(fields, bigCache)}
                </table>
            </div>
        )
    }

    return undefined
}

InlineFeedItem.propTypes = {
    // the Alert cache
    bigCache: PropTypes.object,
    // whether or not we are in searchify
    isSearchify: PropTypes.bool,
    // the unique id of the Inline
    inlineId: PropTypes.number,
    // the qdt
    quorumDataType: PropTypes.object,
}

export default InlineFeedItem
